import { lazy } from 'react';
export const dynamicImport = (importFn) => {
  // Check if we are in a Next.js environment
  try {
    const dynamic = require('next/dynamic');
    if (dynamic) {
      return dynamic(importFn, { ssr: false });
    }
  } catch (e) {
    return lazy(importFn);
  }
};